var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRfid = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 685.4,
  height: 673.9,
  enableBackground: "new 0 0 612 792",
  viewBox: "0 0 685.4 673.9",
  xmlSpace: "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1_1_",
  transform: "translate(36.7,-59.05)",
  display: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m556.4 690.6h-500.8c-25.5 0-46.2-20.7-46.2-46.2v-496.9c0-25.5 20.7-46.2 46.2-46.2h500.7c25.5 0 46.2 20.7 46.2 46.2v496.9c0 25.4-20.8 46.2-46.1 46.2z",
  display: "inline",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "m371.9 191.7h-132.3c-12.3 0-22.5-10.2-22.5-22.5 0-12.4 10.2-22.5 22.5-22.5h132.3c12.3 0 22.5 10.2 22.5 22.5 0 12.4-10 22.5-22.5 22.5z",
  display: "inline",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("text", {
  transform: "translate(100.02 417.19)",
  display: "inline",
  fontFamily: "MyriadPro-Bold",
  fontSize: "191.77px"
}, " DAY"), /*#__PURE__*/React.createElement("rect", {
  x: 100,
  y: 474.2,
  width: 7.1,
  height: 137.7,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 504.8,
  y: 473.5,
  width: 7.1,
  height: 138.4,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 115.3,
  y: 474.1,
  width: 8.3,
  height: 137.7,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 487,
  y: 472.9,
  width: 9.5,
  height: 139.3,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 130.7,
  y: 474,
  width: 14.2,
  height: 137.9,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 461,
  y: 473.5,
  width: 17.8,
  height: 138.4,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 166.2,
  y: 473.4,
  width: 5.9,
  height: 138.3,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 446.7,
  y: 473.3,
  width: 7.1,
  height: 138.5,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 150.8,
  y: 473.5,
  width: 7.1,
  height: 138.3,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 431.4,
  y: 474,
  width: 8.3,
  height: 137.8,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 179.6,
  y: 474.2,
  width: 18.9,
  height: 138,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 343.8,
  y: 473.9,
  width: 14.2,
  height: 138,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 205.6,
  y: 473.8,
  width: 9.5,
  height: 138.4,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 309.1,
  y: 474.4,
  width: 26.9,
  height: 137.4,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 223,
  y: 473.8,
  width: 11.8,
  height: 138,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 290.1,
  y: 473.9,
  width: 8.6,
  height: 138.6,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 243.5,
  y: 474,
  width: 13.4,
  height: 138,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 265.6,
  y: 474.1,
  width: 15.7,
  height: 137.9,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 402.9,
  y: 473.5,
  width: 20.5,
  height: 139.1,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 384.8,
  y: 473.5,
  width: 8.6,
  height: 138,
  display: "inline"
}), /*#__PURE__*/React.createElement("rect", {
  x: 364.2,
  y: 473.3,
  width: 12.7,
  height: 138.5,
  display: "inline"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(38.7,-33.4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m304 328.2c41.8 0 79.5 16.9 107 44.4l-35.7 35.7c-18.2-18.2-43.6-29.6-71.4-29.6s-53 11.4-71.4 29.6l-35.6-35.6c27.4-27.5 65.3-44.5 107.1-44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m125.5 301.2c47.7-47.7 111-73.9 178.4-73.9s130.8 26.3 178.4 73.9l-35.5 35.7c-38.1-38.1-88.8-59.1-142.8-59.1s-104.6 21-142.8 59.1l-35.7-35.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m441.4 154.2c42 17.8 79.9 43.3 112.3 75.8l-35.6 35.6c-57.1-57.2-133.3-88.7-214.1-88.7s-157 31.4-214.1 88.7l-35.6-35.6c32.4-32.4 70.2-57.9 112.3-75.8 43.6-18.5 89.8-27.8 137.6-27.8s93.7 9.3 137.2 27.8z"
}), /*#__PURE__*/React.createElement("g", {
  enableBackground: "new    "
}, /*#__PURE__*/React.createElement("path", {
  d: "m124.5 485.4c9.4-1.5 23.4-2.7 38.9-2.7 19.2 0 32.6 2.9 41.8 10.2 7.7 6.1 11.9 15.2 11.9 27 0 16.5-11.7 27.8-22.8 31.8v0.6c9 3.6 14 12.3 17.3 24.2 4 14.6 8.1 31.5 10.5 36.4h-29.9c-2.1-3.6-5.2-14.2-9-30.1-3.5-16.1-9-20.5-20.9-20.7h-8.8v50.9h-29zm29 55.7h11.5c14.6 0 23.2-7.3 23.2-18.6 0-11.9-8.1-17.8-21.5-18-7.1 0-11.1 0.6-13.2 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m238.2 483.7h79v24h-49.7v29.5h46.5v23.8h-46.4v52h-29.3v-129.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m368.6 483.7v129.3h-29.3v-129.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m393.9 485.4c10.7-1.7 24.7-2.7 39.5-2.7 24.5 0 40.5 4.4 52.9 13.8 13.4 10 21.9 25.9 21.9 48.7 0 24.7-9 41.8-21.5 52.4-13.6 11.3-34.3 16.7-59.6 16.7-15.2 0-25.9-1-33.2-1.9zm29.4 105.5c2.5 0.6 6.5 0.6 10.2 0.6 26.5 0.2 43.7-14.4 43.7-45.3 0.2-26.8-15.5-41-40.7-41-6.5 0-10.7 0.6-13.2 1.2z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRfid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rfid.fc2c7332b7e8a75ca5dcda749b071aa2.svg";